/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

function ToggleIcon(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      expanded = _ref.expanded,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 17 : _ref$size,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["onClick", "className", "expanded", "size"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: className,
    onClick: onClick
  }), _react.default.createElement("svg", {
    height: size,
    width: size,
    viewBox: "0 0 24 24"
  }, expanded ? _react.default.createElement("path", {
    d: "M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
  }) : _react.default.createElement("path", {
    d: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
  })));
}

var _default = ToggleIcon;
exports.default = _default;